<template>
  <v-container fluid fill-height align-center justify-content>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-container>
</template>

<script>
export default {
  name: 'Dashboard'
}
</script>

<style></style>
